import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import {
	TableRow as TableRowComponent,
	TableHeaderCell as TableHeaderCellComponent,
} from '@mlc/web-ui-toolkit';

export const TableHeaderCell = styled(TableHeaderCellComponent)`
	letter-spacing: normal;
	padding: 16px 10px 16px 5px;
	text-transform: none;
	white-space: nowrap;

	&& {
		color: ${palette.mlcVeryDarkGrey};
	}
`;

export const TableRowHeader = styled(TableRowComponent)`
	&& {
		background-color: ${palette.mlcLightGrey};
		background-image: none;
	}
`;
